import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { API, useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      // Parse session_id from URL fragment (#session_id=...)
      const hash = window.location.hash || '';
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : null;

      if (!sessionId) {
        navigate('/', { replace: true });
        return;
      }

      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        await refresh();
        // Clear the hash & redirect to home
        window.history.replaceState({}, '', '/');
        navigate('/', { replace: true, state: { user: res.data.user } });
      } catch (e) {
        console.error('Auth exchange failed', e);
        navigate('/', { replace: true });
      }
    };

    run();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 to-orange-50">
      <div className="text-center">
        <Loader2 className="w-10 h-10 animate-spin text-emerald-700 mx-auto mb-3" />
        <p className="text-gray-700 font-medium">Signing you in…</p>
        <p className="text-xs text-gray-500 mt-1">Please wait</p>
      </div>
    </div>
  );
};

export default AuthCallback;
